import { StandaloneArticleHeader } from 'base/components/ArticleHeader';

export const ElleStandaloneArticleHeader: typeof StandaloneArticleHeader = (props) => {
  return <StandaloneArticleHeader withSaveArticle {...props} />;
};
